// Change hex color into RGB
// Adapted from: https://blog.logrocket.com/applying-dynamic-styles-tailwind-css/
export const getRGBColor = (hex: string) => {
  let color = hex.replace(/#/g, "");
  var r = parseInt(color.substr(0, 2), 16);
  var g = parseInt(color.substr(2, 2), 16);
  var b = parseInt(color.substr(4, 2), 16);
  return `${r}, ${g}, ${b}`;
};
